/**
 * description: 图片视频上传——个人素材库选择文件模块
 * created by he.zhikai
 * created on 2017.08.10
 */
"use strict";
angular.module("personalFileModule", [])
    .controller('personalFileCtrl', ['$scope', '$modalInstance', '$timeout', 'trsHttpService', 'fileType', function($scope, $modalInstance, $timeout, trsHttpService, fileType) {
        initStatus();
        initData();

        /**
         * [initStatus description] 初始化状态
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.status = {
                checkboxHoverStatus: "", //文件复选框的悬停状态
                treeOptions: { //结构树配置
                    nodeChildren: "CHILDREN",
                    dirSelectable: true,
                    allowDeselect: false,
                    injectClasses: {
                        ul: "moveDraftTree-ul",
                        li: "moveDraftTree-li",
                        liSelected: "a7",
                        iExpanded: "a3",
                        iCollapsed: "a4",
                        iLeaf: "a5",
                        label: "moveDraftTree-label",
                        labelSelected: "rolegrouplabselected"
                    },
                    isLeaf: function(node) {
                        return node.HASCHILDREN === "false";
                    },
                },
                ifExpand: true //是否展开全部文件
            };
            $scope.data = {
                allFile: {
                    FILEDESC: "全部文件",
                    PERSONALMATERIALID: "0"
                },
                selectedArray: [], //选择的列表数据
                selectedFile: "" //选择的文件夹
            };
            $scope.params = {
                "serviceid": "mlf_releaseSource",
                "methodname": "queryPersonalMaterialsOfFolder",
                "PersonalMaterialId": "0",
                "fileType": fileType,
                "order": "0"
            };
        }

        /**
         * [initData description] 初始化数据
         * @return {[type]} [description]
         */
        function initData() {
            var params = {
                serviceid: "mlf_releaseSource",
                methodname: "queryChildernFolder",
                PersonalMaterialId: "0"
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                $scope.dataForTheTree = data;
                $scope.data.selectedFile = $scope.data.allFile;
                $scope.params.PersonalMaterialId = "0";
                requestData();
            });
        }

        /**
         * [requestData description] 请求列表数据
         * @return {[type]} [description]
         */
        function requestData() {
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, 'get').then(function(data) {
                $scope.data.items = data;
            });
        }

        /**
         * [showToggle description]展开树请求节点
         * @param  {[obj]} node [description] 当前文件夹
         * @return {[type]}      [description]
         */
        $scope.showToggle = function(node) {
            if (node.HASCHILDREN === "true") {
                var params = {
                    serviceid: "mlf_releaseSource",
                    methodname: "queryChildernFolder",
                    PersonalMaterialId: node.PERSONALMATERIALID
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                    node.CHILDREN = data;
                });
            }
        };

        /**
         * [changeChlWidth description] 根据最长栏目的宽度更改所有栏目li的宽度，使其保持一致
         * @return {[type]} [description]
         */
        $scope.changeChlWidth = function() {
            var channelDom = $('.chooseFile_tree_control ul li');
            if(channelDom.length>0) {
                var maxWdith = channelDom[0].offsetWidth || channelDom.width();
                angular.forEach(channelDom, function(data, index) {
                    if(data.offsetWidth > maxWdith) {
                        maxWdith = data.offsetWidth;
                    }
                });
                channelDom.width(maxWdith-20);
            } else {
                $timeout(function() {
                    $scope.changeChlWidth();
                });
            }
        };

        /**
         * [chooseAllFile description] 选择全部文件夹
         * @return {[type]} [description]
         */
        $scope.chooseAllFile = function() {
            $scope.data.selectedFile = $scope.data.allFile;
            $scope.params.PersonalMaterialId = "0";
            requestData();
        };

        /**
         * [chooseFile description] 选择文件夹
         * @param  {[type]} node [description] 当前文件夹
         * @return {[type]}      [description]
         */
        $scope.chooseFile = function(node) {
            $scope.data.selectedFile = node;
            $scope.params.PersonalMaterialId = node.PERSONALMATERIALID;
            requestData();
        };

        /**
         * [cancelFile description]取消选择
         * @return {[type]} [description]
         */
        $scope.cancelFile = function(item) {
            $scope.data.selectedArray.splice($scope.data.selectedArray.indexOf(item), 1);
        };

        /**
         * [isChecked description] 选中状态
         * @param  {[type]}  item [description]
         * @return {Boolean}      [description]
         */
        $scope.isChecked = function(item) {
            var ischecked = false;
            for (var i = 0; i < $scope.data.selectedArray.length; i++) {
                if ($scope.data.selectedArray[i].PERSONALMATERIALID == item.PERSONALMATERIALID) {
                    ischecked = true;
                    break;
                }
            }
            return ischecked;
        };

        /**
         * [selectDoc description] 单选
         * @param  {[type]} item [description] 选中的文件
         * @return {[type]}      [description]
         */
        $scope.selectDoc = function(item) {
            if ($scope.data.selectedArray.indexOf(item) < 0) {
                $scope.data.selectedArray.push(item);
            } else {
                $scope.data.selectedArray.splice($scope.data.selectedArray.indexOf(item), 1);
            }
        };

        /**
         * [findChildrenFile description] 查看文件夹内的子文件，或文件详情
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.findChildrenFile = function(item) {
            if (item.FILETYPE == "0") {
                $scope.params.PersonalMaterialId = item.PERSONALMATERIALID;
                requestData();
            }
        };

        /**
         * [confirm description] 确定
         * @return {Boolean} [description]
         */
        $scope.confirm = function() {
            $modalInstance.close($scope.data.selectedArray);
        };

        /**
         * [cancel description] 取消
         * @return {[type]} [description]
         */
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };

    }]);